export default __webpack_public_path__ + "static/media/background.1e35652f.jpeg";